import React, { forwardRef } from 'react';

import './index.sass'
import Text from 'components/Text';
//import { serialize } from 'object-to-formdata';
import { Formik } from 'formik';
import { Button } from 'components/Button';
import bem from 'utils/bem';
//import { useToasts } from 'react-toast-notifications';
import TextField from 'forms/fields/TextField';
import BirthdayField from 'forms/fields/BirthdayField';
import { observer } from 'mobx-react-lite';
import EmailField from 'forms/fields/EmailField';
import GenderField from 'forms/fields/GenderField';
import Model from '../../../../model';
import TextareaField from 'forms/fields/TextareaField';
import { useNavigate } from 'react-router';
import validationSchema from './validationSchema';
import { toast } from 'react-hot-toast';

const { block, el } = bem( 'profile-form', 'form' );

const ProfileForm =  forwardRef( ({ defaultValues, turnOffEditMode }, ref ) => {
    const { updateUser } = Model.user;
    const navigate = useNavigate();

    const handleSubmit = (values, form) => {
        const { email, firstName, lastName, skype, birthday, sex, ask } = values;
        updateUser({ email, firstName, lastName, skype, birthday, sex, ask }).then((response) => {
            if (response.userId && response.customerId) {
                navigate('/profile', { replace: true });
                turnOffEditMode();
            } else {
                form.setSubmitting(false);
                toast.error(response);
            }
        });
    };

    const rForm = ( form ) => {
        return (
            <form className={ block() } onSubmit={ form.handleSubmit } ref={ref}>
                <div className={ el( 'fields' ) }>
                    <div className={ el( 'name' ) }>
                        <TextField
                            placeholder={'Ваше имя'}
                            name='firstName'
                        />
                    </div>
                    <div className={ el( 'surname' ) }>
                        <TextField
                            placeholder={'Ваше фамилия'}
                            name='lastName'
                        />
                    </div>
                    <div className={ el( 'email' ) }>
                        <EmailField
                            name='email'
                        />
                    </div>
                    <div className={ el( 'skype' ) }>
                        <TextField
                            placeholder={'Ваш Skype'}
                            name='skype'
                        />
                    </div>
                    <div className={ el( 'sex' ) }>
                        <GenderField
                            placeholder={'Пол'}
                            name='sex'
                        />
                    </div>
                    <div className={ el( 'birthday' ) }>
                        <BirthdayField
                            name='birthday'
                        />
                    </div>
                    <div className={ el( 'ask' ) }>
                        <TextareaField
                            placeholder={'Запрос к специалисту'}
                            name="ask"
                        />
                    </div>
                </div>
                <div className={ el( 'buttons' ) }>
                    <Button className={ el( 'cancel' ) }
                            mod='transparent-gold'
                            type={'button'}
                            onClick={turnOffEditMode} >
                        <Text>Отмена</Text>
                    </Button>
                    <Button className={ el( 'button', 'submit' ) }
                            type='submit'
                            mod={  'gold'  }
                            disabled={form.isSubmitting} >
                        <Text>Сохранить</Text>
                    </Button>
                </div>
            </form>
        );
    };

    return (
        <Formik
            initialValues={ defaultValues }
            onSubmit={ handleSubmit }
            enableReinitialize={ true }
            validationSchema={validationSchema}
            validateOnChange={ false }
            validateOnBlur={ false }>
            { rForm }
        </Formik>
    )
});

export default observer( ProfileForm );
